/**
 * NzContent
 * 
 * @Author: Focci
 * @Date: 2024-03-07 17:24:03
 * @Last Modified by: Focci
 * @Last Modified time: 2024-03-07 17:24:03
 */

import { useTranslations } from 'next-intl'
import { DevelopmentIcons } from './lib'

export default function NzContent({
  house,
  handleIconClick = () => {}
}) {
  const ts = useTranslations('search')
  const th = useTranslations('house')
  
  return (
    <div className="flex flex-col justify-between gap-4">
      <div className="flex flex-col gap-y-4">
        <div>
          <span className="text-helper">{`${ts('urbanPlanning')}:`}</span>
          <span className="ml-2">{house.unitaryPlanZone || '-'}</span>
        </div>
        <div>
          <span className="text-helper">{`${th('landArea')}:`}</span>
          <span className="ml-2">
            {(house.landarea && house.landarea !== '0') ? `${house.landarea}m²` : '-'}
          </span>
        </div>
        <div>
          <span className="text-helper">{`${th('typeOfTitleDeed')}:`}</span>
          <span className="ml-2">{house.title || '-'}</span>
        </div>
      </div>
      <DevelopmentIcons 
        location={house?.regionId ? [house.regionId] : []}
        onClick={handleIconClick}
      />
    </div>
  )
}
